import styled from "styled-components";
import GradientSection from "./GradientSection";

const PartnersContainer = styled.div`
    padding: 30px 15px 20px 15px;

    header {
        text-transform: uppercase;
        color: #FFF;
        font-weight: bold;
        font-size: 1.1rem;
        letter-spacing: 5px;
        text-align: center;
        position: relative;
        margin-bottom: 20px;
    }

    header:before, header:after {
        content: "";
        width: 30%;
        height: 2px;
        background: #FFF;
        display: block;
        position: absolute;
        top: 50%;
    }

    header:before {
        left: 0;
    }

    header:after {
        right: 0;
    }

    main {
        display: flex;
        flex-wrap: wrap;
    }

    main > div {
        width: 33%;
        padding: 30px 50px;
    }

    @media (max-width: 800px) {
        header {
            padding: 0 50px;
        }

        header:before, header:after {
            width: 10%;
        }

        main > div {
            padding: 30px 10px;
        }

        main > div img {
            width: 100%;
        }
    }
`;

type PartnersSectionProps = {
    title: string;
    children: any;
};

const PartnersSection: React.FC<PartnersSectionProps> = ({ title, children }) => {
    return (
        <GradientSection fromColor="#1C1C1C" toColor="#454545">
            <PartnersContainer className="container">
                <header>
                    {title}
                </header>

                <main>
                    {children}
                </main>
            </PartnersContainer>
        </GradientSection>
    );
};

export default PartnersSection;
